import React from 'react';
import PropTypes from 'prop-types';
import classes from './DefinitionsList.module.scss';

export const DefinitionsList = ({ list }) => {
    return (
        <div className={classes.root}>
            {list.map(({ key, term, definition }) => (
                <div key={key}>
                    <div className={classes.term}>{term}</div>
                    <div className={classes.definition}>{definition || '-'}</div>
                </div>
            ))}
        </div>
    );
};

DefinitionsList.propTypes = {
    list: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            term: PropTypes.string.isRequired,
            definition: PropTypes.string
        }).isRequired
    ).isRequired
};
